import React from "react";
import PropTypes from "prop-types";

const MonthSelect = ({
  selectedMonth,
  selectedMonthName,
  months,
  onChange,
  className = "col-sm-3",
}) => (
  <div className={className}>
    <select className="form-select" name="selectedMonth" onChange={onChange}>
      <option defaultValue disabled={!!(selectedMonth || selectedMonthName)}>
        Select Month
      </option>
      <option value="AllMonths">All Months</option>
      {months.map((month, index) => (
        <option key={index} value={JSON.stringify(month.tran_date)}>
          {month.name}
        </option>
      ))}
    </select>
  </div>
);

MonthSelect.propTypes = {
  selectedMonth: PropTypes.string,
  selectedMonthName: PropTypes.string,
  months: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      tran_date: PropTypes.shape({
        $gte: PropTypes.string.isRequired,
        $lte: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default MonthSelect;
